import { useRef, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-scroll";
import ScrollContainer from "react-indiana-drag-scroll";
import useScreen from "../../../providers/screen";
import Loading from "./Loading";
import { HeaderContainer, HeaderItem, HeaderImg, HeaderTitle } from "./style";

const Header = (props) => {
  const { screen } = useScreen();

  const counter = useRef(0);
  const categoryRef = useRef();

  const { theme, categories } = props;

  const [active, setActive] = useState(false);
  const [loadingCategory, setLoadingCategory] = useState(true);

  const categoryLoaded = () => {
    counter.current += 1;

    if (counter.current >= categories.length) {
      setLoadingCategory(false);
    }
  };

  return (
    <>
      <HeaderContainer theme={theme} isDesktop={screen?.isDesktop}>
        <HeaderItem ref={categoryRef}>
          <ScrollContainer className="scroll-container">
            <Loading isLoading={loadingCategory} />
            {categories.map((category, index) => {
              var keyId = String(category?.id);

              return (
                <Link
                  key={index}
                  offset={screen?.isDesktop ? -170 : -152}
                  // offset={-148}
                  activeClass="active"
                  className={`headerFoodItem ${keyId} ${
                    active === keyId ? "active" : ""
                  }`}
                  to={keyId}
                  spy={true}
                  smooth={true}
                  onSetActive={(e) => {
                    setActive(e);

                    if (Number(e) > 3)
                      categoryRef.current.scrollLeft = Number(e) * -50;
                    else categoryRef.current.scrollLeft = Number(e) * 0;
                  }}
                  duration={500}
                  onLoad={categoryLoaded}
                >
                  <HeaderImg
                    src={category.icon_url}
                    className="headerFoodImg"
                  />
                  <HeaderTitle theme={theme}>{category.name}</HeaderTitle>
                </Link>
              );
            })}
          </ScrollContainer>
        </HeaderItem>
      </HeaderContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Header);
